@import "../../global/normalize.css";

/**
 * @prop --ic-z-index-menu: z-index of menu
 */

@media (prefers-reduced-motion: no-preference) {
  :host(.ic-menu-open) .menu {
    transition: max-height var(--ic-transition-duration-slow);
  }
}

:host {
  max-height: 0;
  width: var(--menu-width, var(--input-width, 20rem));
  color: var(--menu-item-text-color, var(--ic-menu-list-option-text-color));

  --ic-typography-color: var(
    --menu-item-text-color,
    var(--ic-menu-list-option-text-color)
  );

  background-color: var(
    --menu-bg-color,
    var(--ic-menu-list-option-background-color)
  );
  position: relative;
  z-index: var(--ic-z-index-menu);
  box-sizing: border-box;
  box-shadow: var(--ic-elevation-overlay);
  border-radius: var(--ic-border-radius);
}

:host(.ic-menu-open:not(.ic-menu-no-focus):focus-within) {
  box-shadow: var(--ic-border-focus);
  outline: var(--ic-hc-focus-outline);
}

:host(.ic-select-select-all-focused) {
  box-shadow: var(--ic-elevation-overlay) !important;
}

#retry-button::part(button) {
  height: var(--ic-space-lg);
}

.small #retry-button::part(button) {
  height: var(--ic-space-md);
}

:host(.on-dialog) {
  inset: auto !important;
}

.menu {
  text-decoration: none;
  list-style-type: none;
  border-radius: 1px;
  background-color: var(
    --menu-bg-color,
    var(--ic-menu-list-option-background-color)
  );
  visibility: hidden;
  max-height: 0;
  overflow-y: hidden;
}

.menu:has(+ .option-bar) {
  border-radius: 0 0 1px 1px;
}

.menu-scroll {
  overflow-y: auto;
}

.menu:focus-visible {
  outline: none;
}

:host(.ic-menu-open) {
  max-height: none;
  display: flex;
  flex-direction: column-reverse;
  border: var(--ic-border-width) solid
    var(--menu-border-color, var(--ic-menu-border-color));
  transition: box-shadow var(--ic-easing-transition-fast);
}

:host(.ic-menu-open) .menu {
  visibility: visible;
  max-height: calc(var(--ic-space-xl) * 10 + var(--ic-space-xxxs));
}

:host(.ic-menu-open) .option-bar {
  visibility: visible;
}

:host(.ic-menu-open) .select-all-button {
  display: block;
}

:host(.ic-menu-full-width) {
  width: 100%;
}

.option {
  padding: var(--ic-space-xs) calc(var(--ic-space-xs) - var(--ic-space-1px));
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: var(--ic-space-xs);
}

.loading-option p {
  margin-bottom: 0 !important;
}

.option:not(.loading-option) {
  justify-content: space-between;
}

:host(.ic-menu-small) .option {
  padding: var(--ic-space-xxs) calc(var(--ic-space-xs) - var(--ic-space-1px));
}

:host(.ic-menu-large) .option {
  padding: var(--ic-space-sm) calc(var(--ic-space-xs) - var(--ic-space-1px));
}

.option:last-child {
  border-radius: 0 0 1px 1px;
}

:not(.menu:has(+ .option-bar)) .option:first-child {
  border-radius: 1px 1px 0 0;
}

.option:not(.disabled-option):hover {
  background-color: var(--ic-menu-list-option-hover-background-color);
}

.option:not(.disabled-option):active {
  background-color: var(--ic-menu-list-option-pressed-background-color);
}

.option:focus-visible {
  outline: var(--ic-hc-focus-outline);
}

.option:not(.disabled-option) .option-description {
  --ic-typography-color: var(
    --menu-item-desc-text-color,
    var(--ic-menu-list-option-description-text-color)
  );
}

.option .option-label {
  display: flex;
  flex-direction: row;
  align-items: top;
}

.option .option-label ic-typography {
  max-width: 100%;
  word-wrap: break-word;
}

.option .option-element {
  margin-top: var(--ic-space-xxs);
}

.option .option-icon {
  height: var(--ic-space-md);
  width: var(--ic-space-md);
  margin-top: var(--ic-space-xxs);
  margin-right: var(--ic-space-xxs);
}

.option-text-container {
  pointer-events: none;
  width: 100%;
}

.option-text-container.show-check-icon {
  flex-grow: 1;
}

.option.loading-option .option-text-container {
  margin-left: calc(var(--ic-space-xs) + var(--ic-space-xxxs));
  color: var(--ic-menu-loading-list-option-text-color);

  --ic-typography-color: var(--ic-menu-loading-list-option-text-color);
}

.error-icon-svg {
  height: var(--ic-space-md);
  width: var(--ic-space-md);
  fill: var(--ic-atoms-status-icon-error);
  align-self: center;
  display: flex;
  margin-right: calc(var(--ic-space-xxs) * 1.2);
}

.loading-error-info {
  display: flex;
}

.check-icon {
  height: var(--ic-space-lg);
  min-width: var(--ic-space-lg);
  width: var(--ic-space-lg);
  pointer-events: none;
}

.focused-option .check-icon * {
  fill: currentcolor;
}

:first-child > .option-group-title {
  padding: var(--ic-space-xs) calc(var(--ic-space-xs) - var(--ic-space-1px))
    var(--ic-space-xs);
}

.option-group-title {
  padding: var(--ic-space-lg) calc(var(--ic-space-xs) - var(--ic-space-1px))
    var(--ic-space-xs);

  --ic-typography-color: var(--ic-menu-option-group-label-text-color);
}

:host(.ic-menu-small) .option-group-title {
  padding: var(--ic-space-sm) calc(var(--ic-space-xs) - var(--ic-space-1px))
    var(--ic-space-xxs);
}

.last-recommended-option {
  border-bottom: var(--ic-menu-last-recommended-option-border);
}

.disabled-option {
  color: var(--ic-atoms-list-option-text-disabled-light);

  --ic-typography-color: var(--ic-atoms-list-option-text-disabled-light);

  cursor: default;
  pointer-events: none;
}

.focus-border {
  border-radius: var(--ic-border-radius);
  padding: var(--ic-space-xxs);
  border: var(--ic-space-xxxs) dashed transparent;
  border-color: var(--ic-popover-menu-border);
  background-color: var(--ic-color-focus-inner) !important;

  --icon-height: auto;
}

.focus-disabled {
  background-color: var(--ic-color-focus-inner) !important;
  padding: calc(var(--ic-space-xs) - var(--ic-space-xxxs) - var(--ic-space-xxs))
    calc(
      var(--ic-space-xs) - var(--ic-space-1px) - var(--ic-space-xxxs) -
        var(--ic-space-xxs)
    );
}

.focused-option,
.focused-option .option-description {
  background-color: var(--ic-color-focus-inner) !important;
  color: var(--ic-atoms-list-option-text-focused-light) !important;

  --ic-typography-color: var(
    --ic-atoms-list-option-text-focused-light
  ) !important;
}

:host(.no-results) li {
  cursor: no-drop;
}

:host(.no-results) li:hover {
  background-color: transparent;
}

.option-bar {
  padding: var(--ic-space-xxs) var(--ic-space-xs);
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--ic-menu-option-bar-background-color);
  visibility: hidden;
  border-bottom: var(--ic-border-width) solid
    var(--ic-menu-option-bar-divider-color);
  border-radius: 1px 1px 0 0;
}

.option-bar p {
  margin-bottom: 0 !important;
}

:host(.ic-menu-large) .option-bar {
  padding: var(--ic-space-xs);
}

.select-all-button {
  display: none;
}

.select-all-button:focus {
  z-index: calc(var(--ic-z-index-menu) + 1);
}

@media (forced-colors: active) {
  .focused-option {
    outline: none;
    border: 0.125rem solid transparent;
  }

  .disabled-option {
    color: GrayText;

    --ic-typography-color: GrayText;
  }
}

/* Breakpoint value chosen as it's a small amount bigger than the menu's default width */
@media screen AND (max-width: 22rem) {
  :host {
    max-width: var(--menu-width, var(--input-width, 20rem));
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  :host(.ic-menu-open) {
    transition: none;
  }
}
